import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./i18n"; // initialize i18next (language detection + resources) before render
import "./services/errorReport"; // errors from the logger also go to Cloud Logging
import App from "./App";
import { warnIfSeasonOverride } from "./features/themes/useActiveSeason";

warnIfSeasonOverride();

// HelmetProvider stays outermost so every route's <SEO> can write the <head>.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
